<template>
  <div v-if="hasYtd" class="ytdval narrow_05">
    {{ getResult=='-' && getYear=='' ? '' : 'YTD'}}{{ getYear }}<span class="bold">{{ getResult=='-' && getYear=='' ? '' : getResult }}</span>
  </div>
  <div v-else class="ytdval narrow_05">
  </div>
</template>

<script>

export default {
  props:{
    ytd: { type: Object, default: undefined },
    showInlineYtd: { type: Boolean, default: false }
  },

  computed: {
    getResult() {
      return this.hasYtd ? this.ytd.Result : '-';
    },

    getYear() {
      return this.hasYtd ? `${this.ytd.Year - 2000}: ` : '';
    },

    hasYtd() {
      return this.ytd && this.ytd.Result !== undefined;
    }
  }
}
</script>

<style lang="scss" scoped>

.ytdval {
  padding-inline-start: 2px;
  font-size: 9pt;
  text-align: left;
}

</style>